import React from "react";
import {connect} from "react-redux";
import BsForm from "components/form/BsForm";
import BsFormPanel from "components/form/BsFormPanel";
import {fetchMaintenanceIssueInfo} from "core/actions/maintenance-actions";
import CLIENT_USER_SUPPORT_ISSUE_INFO from "./client-user-support-issue-info";
import SupportIssueImages from "../../../../../../admin/cusomer-support/form/SupportIssueImages";

import './client-user-problem-issue-info.scss'

class ClientUserProblemIssueInfo extends React.Component {

  constructor(props) {
    super(props);
    this.props.fetchMaintenanceIssueInfo(this.props.match.params.issueId);
  }

  render() {
    if (this.props.currentIssue) {
      const formConfig = {
        ...CLIENT_USER_SUPPORT_ISSUE_INFO,
        title: {
          back: {
            url: '/global/user/' + this.props.match.params.userId + '/reported-problems',
            history: this.props.history,
            location: this.props.location
          },
          text: 'issue_info.title'
        }
      };

      return (
          <BsFormPanel size="m">
            <BsForm
                config={formConfig}
                formData={this.props.currentIssue}
                disabled={true}/>

            <SupportIssueImages images={this.props.currentIssue.images}
                                title={this.props.currentIssue.problem}
                                desc={this.props.currentIssue.description}/>
          </BsFormPanel>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentIssue: state.maintenance.currentIssue
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMaintenanceIssueInfo: (issueId) => {
      dispatch(fetchMaintenanceIssueInfo(issueId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientUserProblemIssueInfo);
